"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _clipboard = _interopRequireDefault(require("clipboard"));
var _showTooltip = _interopRequireDefault(require("./show-tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default() {
  document.querySelectorAll('.copy-text').forEach(function (button) {
    new _clipboard["default"](button).on('success', function (e) {
      (0, _showTooltip["default"])(e.trigger);
      global.copiedText = e.text;
    });
    if (button.classList.contains('prevent-default')) {
      button.addEventListener('click', function (e) {
        return e.preventDefault();
      });
    }
  });
};